import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSpacebar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconSpacebar"><Path d="M2 17.25V13.75C2 13.3358 2.33579 13 2.75 13C3.16421 13 3.5 13.3358 3.5 13.75V17.25C3.5 17.9404 4.05964 18.5 4.75 18.5H19.25C19.9404 18.5 20.5 17.9404 20.5 17.25V13.75C20.5 13.3358 20.8358 13 21.25 13C21.6642 13 22 13.3358 22 13.75V17.25C22 18.7688 20.7688 20 19.25 20H4.75C3.23122 20 2 18.7688 2 17.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSpacebar;
